import type { SVGProps } from 'react';
const DawnFlagRW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-RW_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-RW_svg__a)">
      <g filter="url(#dawn-flag-RW_svg__b)">
        <path
          fill="#2D754D"
          fillRule="evenodd"
          d="M0 16h22v-4.267H0z"
          clipRule="evenodd"
        />
      </g>
      <path fill="#25B1EB" fillRule="evenodd" d="M0 7.467h22V0H0z" clipRule="evenodd" />
      <path
        fill="#FECB2F"
        fillRule="evenodd"
        d="M0 11.733h22V7.467H0zM16.762 4.8l-.802.904.061-1.216-1.195.062.889-.817-.889-.816 1.195.062-.06-1.217.801.905.802-.905-.061 1.217 1.195-.062-.888.816.888.817-1.195-.062.061 1.216z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="dawn-flag-RW_svg__b"
        width={22}
        height={4.267}
        x={0}
        y={11.733}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_1512" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_1512" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagRW;
